"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSpacing = exports.SortDirection = exports.CellType = void 0;
var TableSpacing;
exports.TableSpacing = TableSpacing;

(function (TableSpacing) {
  TableSpacing["Default"] = "default";
  TableSpacing["Reduced"] = "reduced";
})(TableSpacing || (exports.TableSpacing = TableSpacing = {}));

var SortDirection;
exports.SortDirection = SortDirection;

(function (SortDirection) {
  SortDirection["None"] = "none";
  SortDirection["Ascending"] = "ascending";
  SortDirection["Descending"] = "descending";
})(SortDirection || (exports.SortDirection = SortDirection = {}));

var CellType;
exports.CellType = CellType;

(function (CellType) {
  CellType["Data"] = "Data";
  CellType["Header"] = "Header";
})(CellType || (exports.CellType = CellType = {}));